'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { PageNavigation } from '@/components/client';
import { DesktopTitle } from '../_components/DesktopTitle';
import { AccumulatedSection } from './_components/AccumulatedSection';
import { HistoryListSection } from './_components/HistoryListSection';
import { ShareBottomNavPortal } from './_components/ShareBottomNavPortal';
const DonationMyInvitePage = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <article className={cn("flex flex-1 flex-col gap-16", "mobile-tablet:pt-16")}><PageNavigation isNotUsedHomeButton={true} donationHomeButton={true} /><DesktopTitle>친구 초대 현황</DesktopTitle><AccumulatedSection /><HistoryListSection /><ShareBottomNavPortal /></article>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default DonationMyInvitePage;